@for (option of options; track option) {
  <mat-checkbox (change)="onChecked(option.value, $event.checked)" [checked]="isChecked(option.value)">{{ option.label }}</mat-checkbox>
}
